import { PATHS } from '../config';
import { dynoapeAPI } from '../dynoape';
import type { OrgEmployee } from './Models';

const getAllOrgEmployees = async (orgId: string): Promise<OrgEmployee[]> =>
    await dynoapeAPI.get(PATHS.orgEmployees(orgId));

/*
 * Removes the employee link from an org employee (the employee no longer
 * maps to the org employee's external id).
 */
const deleteEmployeeLink = async (
    orgId: string,
    orgEmployeeId: string,
    employeeId: string,
): Promise<true> =>
    (await dynoapeAPI.delete(
        PATHS.orgEmployeeEmployee(orgId, orgEmployeeId, employeeId),
    )) ?? true;

const OrgEmployeeService = {
    getAllOrgEmployees,
    deleteEmployeeLink,
};

export default OrgEmployeeService;
